module.exports = __webpack_public_path__ + "1f14e988b2453cc3ec03ea21130ee656.svg";